import { FC, useEffect, useState } from 'react';
import { useFormContext } from '../../../../../contexts/FormContext';
import { useOutputAreaContext } from '../../../../../contexts/OuputAreaContext';
import { BasicButton } from '../../../../shared/buttons/BasicButton';

// import styles from './RevisePopup.module.css';

export const RevisePopup: FC = () => {
  const { loading } = useFormContext();
  const {
    textareaScrollOffset,
    revisePopupPosition,
    setRevisePopupPosition,
    insertText,
  } = useOutputAreaContext();
  const [leftPosition, setLeftPosition] = useState<number>(20);

  useEffect(() => {
    if (loading) {
      setRevisePopupPosition(undefined);
    }
  }, [loading]);

  useEffect(() => {
    const reviseButton = document.getElementById(
      'revise-output-button'
    ) as HTMLButtonElement;
    if (!reviseButton || !revisePopupPosition) {
      setLeftPosition(20);
      return;
    }
    const leftPosition =
      revisePopupPosition.x - reviseButton.getBoundingClientRect().width;
    setLeftPosition(Math.max(leftPosition, 20));
  }, [revisePopupPosition, textareaScrollOffset]);

  if (!revisePopupPosition) return null;

  return (
    <BasicButton
      id="revise-output-button"
      type="button"
      disabled={loading}
      text="Regenerate selection"
      image={{
        src: '/icons/Refresh.svg',
        height: 16,
        width: 16,
      }}
      onClick={() => {
        insertText();
      }}
      extraStyles={{
        position: 'absolute',
        top: `${revisePopupPosition.y - textareaScrollOffset + 22.5}px`,
        left: `${leftPosition}px`,
        margin: '0 auto',
        backgroundColor: 'var(--ea-white)',
        boxShadow: '0px 4px 5px rgba(0, 0, 0, 0.1)',
      }}
    />
  );
};
